export default {"src":"/_next/static/media/diamond.e4a9738d.svg","height":462,"width":507,"blurWidth":0,"blurHeight":0};